const preHandler = function (e) { e.preventDefault(); }

class Draw {
    constructor(el) {
        this.el = el;
        this.canvas = document.getElementById(this.el);
        this.cxt = this.canvas.getContext("2d");
        this.stage_info = this.canvas.getBoundingClientRect();
        this.path = {
            beginX: 0,
            beginY: 0,
            endX: 0,
            endY: 0,
        };
    }
    init(btn) {
        var that = this;
        //初始化生成
        this.canvas.addEventListener("touchstart", function (event) {
            console.log('touchStart')
            document.addEventListener("touchstart", preHandler, false);
            that.drawBegin(event);
        });
        this.canvas.addEventListener("touchend", function (event) {
            console.log('touchEnd')
            document.addEventListener("touchend", preHandler, false);
            that.drawEnd();
        });
        this.clear(btn);
    }
    drawBegin(e) {
        this.stage_info = this.canvas.getBoundingClientRect();
        var that = this;
        window.getSelection()
            ? window.getSelection().removeAllRanges()
            : document.selection.empty();
        this.cxt.strokeStyle = "#000";
        this.cxt.beginPath();
        console.log('e', e)
        console.log('e', this.stage_info)

        this.cxt.moveTo(
            e.changedTouches[0].clientX - this.stage_info.left,
            e.changedTouches[0].clientY - this.stage_info.top
        );
        this.path.beginX = e.changedTouches[0].clientX - this.stage_info.left;
        this.path.beginY = e.changedTouches[0].clientY - this.stage_info.top;
        this.canvas.addEventListener("touchmove", function (ev) {
            ev.preventDefault();
            that.drawing(event);
        });
    }
    drawing(e) {
        this.cxt.lineTo(
            e.changedTouches[0].clientX - this.stage_info.left,
            e.changedTouches[0].clientY - this.stage_info.top
        );
        this.path.endX = e.changedTouches[0].clientX - this.stage_info.left;
        this.path.endY = e.changedTouches[0].clientY - this.stage_info.top;
        this.cxt.stroke();
    }
    drawEnd() {
        document.removeEventListener("touchstart", preHandler, false);
        document.removeEventListener("touchend", preHandler, false);
        document.removeEventListener("touchmove", preHandler, false);
    }
    clear(btn) {
        this.cxt.clearRect(0, 0, this.stage_info.width, this.stage_info.height);
        // this.cxt.clearRect(0, 0, 373, 200)
    }
    save() {
        return this.canvas.toDataURL("image/png");
    }
}

export default Draw